<template>
    <offer-form v-if="reconditionOfferData"
                :allowed-image-types="allowedImageTypes"
                :max-file-size="maxFileSize"
                :offer="reconditionOfferData"
                :save-handler="getHandleReconditionOffer"
                :recondition-mode="true"
                :locale="locale"></offer-form>
</template>

<script>
import OfferForm from "../OfferForm";
import OffersApi from "../../services/OffersApi";

export default {
    name: 'ReconditionOffer',
    components: {OfferForm},
    data() {
        return {
            reconditionOfferData: null
        };
    },
    props: [
        'locale',
        'allowedImageTypes',
        'maxFileSize',
        'deactivatedOfferId',
        'csrfToken'
    ],
    created() {
        OffersApi.getFullOfferData(this.locale, this.deactivatedOfferId).then((response) => {
            this.reconditionOfferData = response.data;
        });
    },
    methods: {
        getHandleReconditionOffer(renewOfferData) {
            return OffersApi.reconditionOffer(renewOfferData, this.locale, this.csrfToken).then(response => {
                return response.json();
            });
        }
    }
};
</script>

<style scoped>
</style>
